import type { ProjectEntity } from "@/entities/project";

import { getLocationAncestors } from "@/entities/ancestor";
import { sortTexts } from "@/utilities/string";

export const filterProjectByLocationsName = (
  project: ProjectEntity,
  locationName: string
) => {
  const locations = getLocationAncestors(project.ancestors);

  return locations.some((location) =>
    location.name.toLowerCase().includes(locationName.toLowerCase())
  );
};

export const sortProjectByLocationsName = (
  a: ProjectEntity,
  b: ProjectEntity
) => {
  const locationsA = getLocationAncestors(a.ancestors);
  const locationsB = getLocationAncestors(b.ancestors);
  return sortTexts(
    locationsA.map(({ name }) => name).join(),
    locationsB.map(({ name }) => name).join()
  );
};
